module.exports = __webpack_public_path__ + "img/02.a352af79.png";